import { isBrowser, parsedJsonOrNull } from '@phx-husky/browser-helpers';

const getLocalStorageData = (key) => {
    var _a;
    const data = isBrowser() ? localStorage.getItem(key) : null;
    return (_a = parsedJsonOrNull(data)) !== null && _a !== void 0 ? _a : data;
};
const setLocalStorageData = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const removeLocalStorageData = (key) => localStorage.removeItem(key);

export { getLocalStorageData, removeLocalStorageData, setLocalStorageData };
